/*
* Copyright (C) Regione Lombardia
*/
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PagesGestioneRilievoCreaRilievoComponent } from './crea-rilievo/crea-rilievo.component';
import { PagesGestioneRilievoDettaglioRilievoComponent } from './dettaglio-rilievo/dettaglio-rilievo.component';
import { GestioneRilievoDettaglioRilievoResolver } from './dettaglio-rilievo/dettaglio-rilievo.resolver';
import { PagesGestioneRilievoModificaRilievoComponent } from './modifica-rilievo/modifica-rilievo.component';
import { GestioneRilievoModificaRilievoResolver } from './modifica-rilievo/modifica-rilievo.resolver';
import { PagesGestioneRilievoRicercaRilievoComponent } from './ricerca-rilievo/ricerca-rilievo.component';

@NgModule({
    imports: [RouterModule.forChild([
        {   path: 'ricerca', 
            component: PagesGestioneRilievoRicercaRilievoComponent ,
        },
        {
            path: 'dettaglio/:idRilievo', 
            component: PagesGestioneRilievoDettaglioRilievoComponent,
            resolve: { additionalInformation: GestioneRilievoDettaglioRilievoResolver },
        },
        {
            path: 'dettaglio/:idRilievo/modifica', 
            component: PagesGestioneRilievoModificaRilievoComponent,
            resolve: { additionalInformation: GestioneRilievoModificaRilievoResolver },
        },
        { path: 'crea', component: PagesGestioneRilievoCreaRilievoComponent },
        { path: '**', redirectTo: 'ricerca' },
    ])],
    exports: [
        RouterModule,
    ]
})
export class PagesGestioneRilievoRoutingModule { }
